import React from 'react'
import { Text } from 'react-native'

const BankTab = () => {
  return <Text>Bank Tab</Text>
}

export default BankTab
